import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTradingViewLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTradingViewLine"><Path d="M1.5 16.2778L6.75 10.1667L14.1 17.5L22.5 6.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTradingViewLine;
